// Generated + curated media assets for MY CHRISTMAS — self-hosted, optimized WebP (1280w + 640w variants in /img/opt).
export const MEDIA = {
  hero: "/img/opt/hero-1280.webp",
  livingRoom: "/img/opt/livingRoom-1280.webp",
  santa: "/img/opt/santa-1280.webp",
  table: "/img/opt/table-1280.webp",
  authBg: "/img/opt/authBg-1280.webp",
  fireplace: "/img/opt/fireplace-1280.webp",
  moon: "/img/opt/moon-1280.webp",
  familyHome: "/img/opt/familyHome-1280.webp",
};

export const MODULE_IMAGES = {
  decoration: "/img/opt/mod-decoration-1280.webp",
  ceia: "/img/opt/mod-ceia-1280.webp",
  recipes: "/img/opt/mod-recipes-1280.webp",
  table: "/img/opt/mod-table-1280.webp",
  budget: "/img/opt/mod-budget-1280.webp",
  planner: "/img/opt/mod-planner-1280.webp",
  gifts: "/img/opt/mod-gifts-1280.webp",
  secretsanta: "/img/opt/mod-secretsanta-1280.webp",
  moment: "/img/opt/mod-moment-1280.webp",
  favorites: "/img/opt/mod-favorites-1280.webp",
  account: "/img/opt/mod-account-1280.webp",
};

export const WORLD_COVERS = {
  BR: "/img/opt/world-BR-1280.webp",
  US: "/img/opt/world-US-1280.webp",
  ES: "/img/opt/world-ES-1280.webp",
  FR: "/img/opt/world-FR-1280.webp",
  IT: "/img/opt/world-IT-1280.webp",
  PT: "/img/opt/world-PT-1280.webp",
};

// Responsive srcSet helper: "/img/opt/x-1280.webp" -> "…-640.webp 640w, …-1280.webp 1280w"
export const srcSet = (url) => (typeof url === "string" && url.endsWith("-1280.webp") ? `${url.replace("-1280.webp", "-640.webp")} 640w, ${url} 1280w` : undefined);

// Recipe photos: "/img/recipes/{id}-1024.webp" -> srcSet with the 640w variant for phones.
export const recipeSrcSet = (url) => (typeof url === "string" && url.endsWith("-1024.webp") ? `${url.replace("-1024.webp", "-640.webp")} 640w, ${url} 1024w` : undefined);
// Absolute URL for sharing (relative self-hosted paths need the origin).
export const absUrl = (url) => (url && url.startsWith("/") ? `${window.location.origin}${url}` : url);

// Any self-hosted photo ("…-1024.webp" or "…-1280.webp") -> srcSet with its 640w variant.
export const imgSrcSet = (url) => {
  if (typeof url !== "string") return undefined;
  const m = url.match(/^(.*)-(1024|1280)\.webp$/);
  return m ? `${m[1]}-640.webp 640w, ${url} ${m[2]}w` : undefined;
};
